import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMonitoring = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M130.001-130.001v-65.768l59.998-59.998v125.766h-59.998Zm160 0v-225.768l59.998-59.998v285.766h-59.998Zm160 0v-285.766l59.998 60.998v224.768h-59.998Zm160 0v-224.768l59.998-59.998v284.766h-59.998Zm160 0v-385.768l59.998-59.998v445.766h-59.998Zm-640-221.232v-84.536L400-705.768l160 160 269.999-269.999v84.536L560-461.232l-160-160-269.999 269.999Z" })
});
export default SvgMonitoring;
